/**
 * XNGAGE CONFIDENTIAL
 * __________________________
 *
 * Copyright (C) 2021 Xngage - All Rights Reserved
 *
 * All code or information contained herein is, and remains the
 * property of Xngage LLC and its customers. The intellectual
 * and technical concepts contained are proprietary to Xngage LLC
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Xngage LLC.
 */
import { sizeVariantValues } from "@insite/mobius/FormField/formStyles";
import { IconWrapper } from "@insite/mobius/Icon";
import { getProp, resolveColor } from "@insite/mobius/utilities";
import getColor from "@insite/mobius/utilities/getColor";
import CaretDown from "@monsma/XDL/Icons/CaretDown";
import { xBaseTheme } from "@monsma/XDL/types";
import { css } from "styled-components";

export default {
    defaultProps: {
        cssOverrides: {
            dropdownWrapper: css`
                line-height: 20px;

                &[aria-expanded="true"] {
                    ${IconWrapper} {
                        transform: rotate(180deg);
                    }
                }
            `,
            list: css`
                box-shadow: none;
                width: 100%;
                border-color: ${getProp("theme.colors.common.ui9")};
                padding: 0;
            `,
            option: css`
                padding: 5px 0 5px 10px;
                line-height: 20px;
                min-height: 46px;
                height: auto;
                font-size: 15px;
                display: flex;
                align-items: center;

                ${({ focused, disabled, selected, theme, noHover }: any) => {
                    let background = resolveColor("common.background", theme);
                    const text = resolveColor("text", theme);
                    const primary = resolveColor("common.border", theme);
                    const hover = primary;
                    if (selected) {
                        background = primary;
                    } else if (focused) {
                        background = hover;
                    }
                    return css`
                        background: ${background};
                        color: ${text};

                        ${!disabled &&
                        !noHover &&
                        `
                            &:hover {
                                background: ${hover};
                                color: ${text};
                            }
                        `}
                        ${disabled ? "cursor: not-allowed; opacity:0.5;" : "cursor: pointer;"}
                    `;
                }}
            `,
            noOptions: css`
                padding: 5px 0 5px 11px;
                line-height: 20px;
                color: ${({ theme }) => resolveColor("text", theme)};
                opacity: 0.5;
                cursor: not-allowed;
            `,
            selectedText: css`
                padding: 0 40px 0 10px;
                text-overflow: ellipsis;
                line-height: ${({ _sizeVariant }: any) => (sizeVariantValues as any)[_sizeVariant].height}px;
            `,
        },
        iconProps: {
            src: CaretDown,
            size: 20,
            color: "common.ui10",
            css: css`
                &&& {
                    width: 35px;
                }
            `,
        },
        css: css`
            &&&& {
                background: ${getColor("common.ui8")};
                overflow: hidden !important;
                text-overflow: ellipsis;
            }
        `,
    },
} as xBaseTheme["dynamicDropdown"];
